import styled from 'styled-components';
import { Heading3, theme } from '@ovotech/element-v5';

export const Heading = styled(Heading3)`
  color: ${theme.color.brand.dark};
`;

export const MonthCard = styled.div`
  background: var(--color-neutral-white);
  border: var(--border-width-sm) solid var(--color-neutral-30);
  border-radius: var(--border-radius-lg);
`;

export const EndOfList = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: ${theme.space[200]};
  color: ${theme.color.brand.dim};
`;
